export default __webpack_public_path__ + "static/media/batch-add-time.7e333eaf.png";